export default __webpack_public_path__ + "static/media/pauseImg.fc01bb29.svg";